import { InjectionToken } from '@angular/core';
import { GridType } from '@data-access/grid-views';
import { DEFAULT_BASE_GRID_PROPS } from '@data-access/shared';
import { UserGrid } from '../types';
import environment from '@environments/environment';

export const USER_URL = `${environment.irisApi}/auth/admin/user/`;

export const userInitialState: UserGrid = {
  data: [],
  currentUrl: '',
  isInternal: true,
  userUpdated: false,
  updatedResult: {
    userId: '',
    message: '',
  },
  gridType: 'user' as GridType,
  views: [],
  ...DEFAULT_BASE_GRID_PROPS,
};

export const USER_GRID_STATE = new InjectionToken<UserGrid>('User grid state', {
  factory: () => ({ ...userInitialState }),
});
